import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const defaultOptions: ToastOptions = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  className: "",
  bodyClassName: "text-black text-center text-base p-0 font-[poppins]",
  closeButton: false,
};

export const pushToasts = {
  report_ready: (msg: string, onClick?: () => void, autoClose = 4000) => {
    toast(
      <div
        className="flex items-center justify-between gap-4 text-left "
        onClick={(e) => {
          e.stopPropagation();
          onClick && onClick();
        }}
      >
        <div className="flex items-center gap-3">
          <img
            src="/report_generation_complete.svg"
            alt="Done"
            className="w-12 h-12"
          />
          <div>
            <h2 className="text-sm font-semibold text-gray-800 text-left">
              Report Ready
            </h2>
            <p className="text-sm text-gray-800 text-left">{msg}</p>
          </div>
        </div>
        <div className="flex flex-1 items-end h-12">
          <button className="text-blue-600 text-sm font-semibold whitespace-nowrap">
            View Report
          </button>
        </div>
      </div>,
      {
        ...defaultOptions,
        autoClose,
        className: `
            bg-white 
            text-black 
            rounded-xl 
            shadow-md 
            p-5 
            flex 
            items-center 
            min-h-[5rem] 
            z-[100!important] 
            mt-[60px] 
            w-[400px] 
            max-w-[400px] 
            right-[85px]
            break-words`,
      }
    );
  },

  project_shared: (msg: string, onClick?: () => void, autoClose = 4000) => {
    toast(
      <div
        className="flex items-center justify-between gap-4 text-left"
        onClick={(e) => {
          e.stopPropagation();
          onClick && onClick();
        }}
      >
        <div className="flex items-center gap-3">
          <img src="/project_shared.svg" alt="Done" className="w-14 h-14" />
          <div>
            <h2 className="text-sm font-semibold text-gray-800 text-left">
              Project Shared
            </h2>
            <p className="text-sm text-gray-800 text-left">{msg}</p>
          </div>
        </div>
        <div className="flex flex-1 items-end h-12">
          <button className="text-blue-600 text-sm font-semibold whitespace-nowrap">
            View Project
          </button>
        </div>
      </div>,
      {
        ...defaultOptions,
        autoClose,
        className: `
            bg-white 
            text-black 
            rounded-xl 
            shadow-md 
            p-5 
            flex 
            items-center 
            min-h-[5rem] 
            z-[100!important] 
            mt-[60px] 
            w-[400px] 
            max-w-[400px] 
            right-[85px]
            break-words`,
      }
    );
  },

  report_shared: (msg: string, onClick?: () => void, autoClose = 4000) => {
    toast(
      <div
        className="flex items-center justify-between gap-4 text-left "
        onClick={(e) => {
          e.stopPropagation();
          onClick && onClick();
        }}
      >
        <div className="flex items-center gap-3">
          <img src="/report_shared.svg" alt="Done" className="w-12 h-12" />
          <div>
            <h2 className="text-sm font-semibold text-gray-800 text-left">
              Report Shared
            </h2>
            <p className="text-sm text-gray-800 text-left">{msg}</p>
          </div>
        </div>
        <div className="flex flex-1 items-end h-12">
          <button className="text-blue-600 text-sm font-semibold whitespace-nowrap">
            View Report
          </button>
        </div>
      </div>,
      {
        ...defaultOptions,
        autoClose,
        className: `
            bg-white 
            text-black 
            rounded-xl 
            shadow-md 
            p-5 
            flex 
            items-center 
            min-h-[5rem] 
            z-[100!important] 
            mt-[60px] 
            w-[400px] 
            max-w-[400px] 
            right-[85px]
            break-words`,
      }
    );
  },
};
